/**
 * Labstep
 *
 * @module components/User/List/Cap
 * @desc List of users
 */

import { ProfilePicture } from 'labstep-web/components/Profile/Picture';
import { Size } from 'labstep-web/core/Initials/types';
import { ListCap } from 'labstep-web/core/List/Cap';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { User } from 'labstep-web/models/user.model';
import type React from 'react';
import type { IUserListCapProps, IUserListProps } from './types';

const UserList: React.FC<IUserListProps> = ({ users, total }) => (
  <ListCap
    circular
    total={total}
    items={users.map((user: User) => (
      <ProfilePicture
        popup
        content={user.username}
        key={user.id}
        entity={user}
        size={Size.mini}
      />
    ))}
  />
);

export const UserListCap: React.FC<IUserListCapProps> = ({
  params,
}) => (
  <ReadOnMountHOC
    type="cursor"
    loading={false}
    entityName={User.entityName}
    params={{
      ...params,
      count: 4,
    }}
    children={({ entities, total }) => (
      <UserList users={entities} total={total} />
    )}
  />
);
